import { useState } from 'react';
import MoreMenu from '@components/MoreMenu';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useTranslation } from '@hooks';
import { handleApiError } from '@helpers/api';
import { downloadBlobAs } from '@helpers/download';

const ExportCSV = ({ type, apiCall }) => {
    const [anchor, setAnchor] = useState({ el: null, id: null });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { t } = useTranslation();

    const handleOpen = (event, id) => {
        event.stopPropagation();
        setAnchor({ id, el: event.currentTarget });
    };

    const handleClose = () => setAnchor(prev => ({ ...prev, el: null }));

    const onExport = async format => {
        try {
            setIsSubmitting(true);
            const file = await apiCall(format);
            const ext = format === 'xlsx' ? 'xlsx' : 'csv';
            downloadBlobAs(file, `${type}.${ext}`);
        } catch (error) {
            handleApiError(error);
        } finally {
            handleClose();
            setIsSubmitting(false);
        }
    };

    const menu = [
        {
            id: `${type}-csv`,
            icon: <FileDownloadIcon sx={{ height: '18px', width: '18px' }} />,
            title: t('buttons.exportAsCSV'),
            onClick: () => onExport('csv'),
            disabled: isSubmitting,
        },
        {
            id: `${type}-xlsx`,
            icon: <FileDownloadIcon sx={{ height: '18px', width: '18px' }} />,
            title: t('buttons.exportAsExcel'),
            onClick: () => onExport('xlsx'),
            disabled: isSubmitting,
        },
    ];

    return <MoreMenu id={type} anchor={anchor} handleOpenEl={handleOpen} handleCloseEl={handleClose} menu={menu} />;
};

export default ExportCSV;
